export default "__VITE_ASSET__81241026__"